import { roundToTwo } from '@/utils/formatting';
import { convertFormulaToDisplay } from '@/components/campaigns/FormulaBuilder/formulaUtils';
import ScoreAnswer from '../ScoreAnswer';
import NoAnswer from './NoAnswer';

import type { CampaignQuestion } from '@/components/campaigns/CampaignQuestionsEditor/types';

interface FormulaAnswerProps {
    answer: string;
    formula?: string;
    prefilledFormula?: string | null;
    allQuestions?: CampaignQuestion[];
}

const FormulaAnswer: React.FC<FormulaAnswerProps> = ({ answer, formula, prefilledFormula, allQuestions = [] }) => {
    if (answer === '' || typeof answer !== 'string') {
        return <NoAnswer />;
    }

    // Server already rounds values to 2 decimal places,
    // but this is added here as a fallback for old data.
    const numericValue = parseFloat(answer);
    const displayValue = String(roundToTwo(numericValue));

    // Get display formula (Q notation)
    const displayFormula = formula && allQuestions.length > 0 ? convertFormulaToDisplay(formula, allQuestions) : null;

    return <ScoreAnswer score={displayValue} displayFormula={displayFormula} prefilledFormula={prefilledFormula} />;
};

export default FormulaAnswer;
